<core-helpers-forms-key-select
    [label]="label"
    [options]="items"
    [placeholder]="placeholder"
    [optionSelected]="optionSelected"
    (actionSelectItem)="onSelectItem($event)"
></core-helpers-forms-key-select>
<span *ngIf="items.length == 0"> NO options here.</span>